import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const InternalControlNumber = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.internalControlNumber"
      control={control}
      render={({ field }) => (
        <FF2
          label="88. Internal control/file number"
          field={field}
          input={(props) => <TextInput {...props} maxLength={50} />}
        />
      )}
    />
  )
}
